export interface FilterItem {
  id: number | string;
  displayName: string;
}

// At most 3 themes / segments per search: the 4th+ options grey out.
export function toLimitedOptions(
  items: FilterItem[],
  selected: FilterItem[] = [],
  limit = 3,
) {
  return items.map((item) => ({
    value: item.id,
    label: item.displayName,
    disabled:
      selected.length >= limit && !selected.some((s) => s.id === item.id),
  }));
}

export function toOptions(items: FilterItem[]) {
  return items.map((item) => ({ value: item.id, label: item.displayName }));
}

// The api objects behind a list of picked ids, in the list's order.
export function pickByIds(items: FilterItem[], ids: Array<number | string>) {
  return items.filter((item) => ids.includes(item.id));
}

// Last day of the trip as YYYY-MM-DD: the night after the last day only counts
// when that day has a hotel.
export function getTripEndDate(
  departureDate: unknown,
  tripDuration: number | undefined,
  days: Array<{ hotelId?: unknown }> | undefined,
) {
  if (!departureDate) return null;

  const duration = Math.max(tripDuration ?? 1, 1);
  const lastDayIndex = Math.min(duration, days?.length ?? 0) - 1;
  const hasHotelOnLastNight =
    lastDayIndex >= 0 && !!days?.[lastDayIndex]?.hotelId;
  const offsetDays = hasHotelOnLastNight ? duration : duration - 1;

  const date = new Date(departureDate as string);
  date.setDate(date.getDate() + offsetDays);

  return date.toISOString().split('T')[0];
}
